<template>
  <el-select
    :value="value"
    :placeholder="placeholder"
    :multiple="multiple"
    class="group-select"
    popper-class="group-select__wrap"
    filterable
    v-bind="$attrs"
    @change="selectChange"
  >
    <el-option-group
      v-for="(group, groupIndex) in groupedOptions"
      :key="groupIndex"
      :label="group.label || group.title"
    >
      <el-option
        v-for="(item, itemIndex) in group.options"
        :key="itemIndex"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-option-group>
  </el-select>
</template>

<script>
export default {
  name: "group-select",
  props: {
    value: {
      required: true
    },
    width: String,
    groupedOptions: Array,
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: Boolean,
    placeholder: {
      type: String,
      default: "请选择"
    }
  },
  methods: {
    selectChange(items) {
      this.$emit("change", items)
      this.$emit("input", items)
    }
  }
}
</script>

<style lang="scss">
.group-select {
  width: 100%;
  margin-top: 10px;
  .el-input__inner {
    border: 1px solid #dcdfe6;
    &:hover {
      border-color: #2196f3 !important;
    }
  }
  .el-select-dropdown__item.hover {
    background-color: transparent;
  }
  .selectListItem:hover {
    color: #fff;
    background-color: #1e88e5;
  }
}
.group-select__wrap {
  .el-select-dropdown__wrap {
    max-height: 350px;
  }
}
</style>
